module.exports = __webpack_public_path__ + "img/도면_당진공장.8564a473.png";